import {
    NewsAndViewsCard,
    NewsAndViewsCardListSkeleton,
    NewsAndViewsCardSkeleton,
} from "./NewsAndViewsCard";

export default NewsAndViewsCard;

export { NewsAndViewsCardSkeleton, NewsAndViewsCardListSkeleton };
